/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_MonthInputs */



/**
* | output |
* | --- |
* | "Month" |
*
* @param {Usage_MonthInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_month = /** @type {((inputs?: Usage_MonthInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_MonthInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mois")
	if (locale === "de") return /** @type {LocalizedString} */ ("Monat")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mese")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Месяц")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("月")
	if (locale === "ja") return /** @type {LocalizedString} */ ("月")
	if (locale === "hi") return /** @type {LocalizedString} */ ("महीना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mês")
	return /** @type {LocalizedString} */ ("Month")
});